import MergeIcon from '@mui/icons-material/Merge';
import { makeObservable } from 'mobx';
import Dominios from '../../util/Dominios';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComVotoConvergente extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação com pelo menos 1 voto convergente (expresso ou tácito)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return (
            registro.votos &&
            registro.votos.findIndex(
                (voto) =>
                    voto.voto?.codigo === Dominios.CODIGO_VOTO_CONVERGENTE ||
                    voto.voto?.codigo === Dominios.CODIGO_VOTO_CONVERGENTE_TACITO
            ) !== -1
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
